import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const contactBlock = (
    <div className="bg-[#F9FFF5] border border-[#2E7D32]/20 p-6 rounded-lg mt-2">
      <p><strong>Sam's Nutri Hub</strong></p>
      <p>Venkatesh Prime, 4th Floor, Burudgaon Road</p>
      <p>Ahmednagar, Maharashtra 414001</p>
      <p>Email: <a href="mailto:hello@samsnutrihub.com" className="text-[#2E7D32] hover:underline">hello@samsnutrihub.com</a></p>
      <p>Phone: <a href="tel:+919637375555" className="text-[#2E7D32] hover:underline">+91 96373 75555</a></p>
    </div>
  );

  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div {...fadeInUp}>
          <p className="text-sm text-[#9E9E9E] mb-2">Last updated: November 1, 2023</p>
          <h1 className="text-4xl font-bold text-[#0B1320] font-poppins mb-10">
            Privacy Policy — Sam's Nutri Hub
          </h1>

          <div className="prose prose-lg max-w-none text-[#4A4A4A] leading-relaxed space-y-8">

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">1. Introduction</h2>
              <p>
                Your privacy is important to us. It is Sam's Nutri Hub's policy to respect your privacy and
                comply with all applicable laws and regulations regarding any personal information we may collect
                about you, including across our website{' '}
                <a href="https://samsnutrihub.com" target="_blank" rel="noopener noreferrer" className="text-[#2E7D32] hover:underline">
                  https://samsnutrihub.com
                </a>{' '}
                and other sites we own and operate.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">2. Personal Information We Collect</h2>
              <p>We collect the following types of personal information:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Full name</li>
                <li>WhatsApp number and email address</li>
                <li>Body metrics: weight, height, age</li>
                <li>Health and wellness goals</li>
                <li>Medical history and dietary restrictions (when relevant to our services)</li>
              </ul>
              <p className="mt-4">
                We collect this data for the purpose of providing our services, identifying and communicating
                with you, and for internal research and development to continuously improve our programs.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">3. Information Collection and Use</h2>
              <p>
                We collect several types of information for various purposes to provide and improve our services.
                Types of data collected include Personal Data, Usage Data, and Tracking &amp; Cookies Data.
                All data is used solely to serve you better and is never sold to third parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">4. Third-Party Sharing</h2>
              <p>
                We share data with <strong>Google</strong> and <strong>Meta (Facebook)</strong> for the
                purposes of better ad targeting and analytics. This helps us reach people who are genuinely
                interested in health and wellness, and improve the relevance of our communications. Your data
                may be processed and stored in countries other than your country of residence, subject to
                appropriate safeguards.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">5. Cookies</h2>
              <p>
                We use both <strong>server-side</strong> and <strong>client-side</strong> tracking via cookies.
                Cookies help us improve your experience on our website and support our analytics and advertising
                efforts. You may manage cookie preferences through your browser settings at any time.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">6. Security of Data</h2>
              <p>
                The security of your data is important to us. We implement appropriate technical and
                organisational measures to protect your information. However, please note that no method of
                transmission over the Internet or method of electronic storage is 100% secure, and we cannot
                guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">7. Your Rights and Choices</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate or incomplete information</li>
                <li>Request deletion of your personal information (subject to legal obligations)</li>
                <li>Opt out of marketing communications at any time</li>
              </ul>
              <p className="mt-4">
                To exercise any of these rights, please contact us at the details below.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">8. Children's Privacy</h2>
              <p>
                Our services do not address anyone under the age of 13. We do not knowingly collect personally
                identifiable information from children under 13. If we become aware that such information has
                been collected, we will take immediate steps to delete it.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">9. Changes to This Policy</h2>
              <p>
                We reserve the right to make changes to this Privacy Policy at any time. We encourage you to
                review this page regularly. Continued use of our services after any changes constitutes your
                acceptance of the updated policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">10. Contact Us</h2>
              <p>
                For more information about our privacy practices, or if you have questions or wish to make a
                complaint, please contact us:
              </p>
              {contactBlock}
            </section>

          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;